import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { useSelectedProvider } from '../../../../components/App/ProviderContainer/useSelectedProvider';
import { CreateTransferRequest, TransfersEntity } from '../../../DirectPayments/models/transfer';
import { AppState } from '../../../../stores/redux-store';
import { useConfiguration } from '../../../../components/ApplicationProviders/ConfigurationProvider/ConfigurationProvider';
import { createTransfer as createDirectTransfer } from '../../services/transfers';
import { applicationParameters } from '../../../../utilities/application-parameters';
import { getCredentialsAppUri } from '../../../../utilities/app-uri/app-uri';
import { useSelectedAuthenticationOptions } from '../../../hooks/useSelectedAuthenticationOptions/useSelectedAuthenticationOptions';
import { navigateUserToInitialTinkLinkAfterThirdPartyRedirect } from '../../../../models/configuration';

export type CreateTransferProps = {
  credentialsId: string;
  sourceUri?: string;
  appUri?: string;
  createTransferRequest?: Partial<CreateTransferRequest>;
};

export type CreateTransfer = (props: CreateTransferProps) => void;

type UseCreateTransfer = () => {
  createTransfer: CreateTransfer;
  transfer?: TransfersEntity;
};

export const useCreateTransfer: UseCreateTransfer = () => {
  const dispatch = useDispatch();
  const transfer = useSelector((state: AppState) => state.transfer.data);
  const { data: config } = useConfiguration();
  const { selectedProvider } = useSelectedProvider();
  const selectedAuthenticationOptions = useSelectedAuthenticationOptions(selectedProvider);
  const requestId = applicationParameters.get('paymentRequestId') as string;

  const createTransfer = useCallback(
    ({ sourceUri, credentialsId, appUri, ...createTransferRequest }: CreateTransferProps) => {
      dispatch(
        createDirectTransfer(
          {
            credentialsId,
            sourceUri,
            requestId,
            selectedProvider: selectedProvider.name,
            redirectUri:
              appUri ||
              getCredentialsAppUri({
                redirectToReferPage: false,
                navigateToInitialTinkLinkRedirect:
                  navigateUserToInitialTinkLinkAfterThirdPartyRedirect(config),
              }),
            ...selectedAuthenticationOptions,
            ...createTransferRequest,
          },
          config
        )
      );
    },
    [config, dispatch, requestId, selectedAuthenticationOptions, selectedProvider.name]
  );

  return { createTransfer, transfer };
};
